import { render, staticRenderFns } from "./select-rock-paper-scissors.vue?vue&type=template&id=46060684"
import script from "./select-rock-paper-scissors.vue?vue&type=script&lang=js"
export * from "./select-rock-paper-scissors.vue?vue&type=script&lang=js"
import style0 from "./select-rock-paper-scissors.vue?vue&type=style&index=0&id=46060684&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports